/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actionTypes from './ActionTypes';

const axiosPayLoad = {
  showPreLoader: false,
};

const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.SET_PRELOADER:
      return {
        ...state,
        showPreLoader: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
